import React from 'react';

import './submenu.scss';

const TopSubmenu = ({children, classes="card shadow-sm bg-white mt-3"}) => {

    return (
        <div className={classes}>
            <div className="card-body p-0 pl-4 pt-2">
                <div className="top-submenu">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default TopSubmenu;
